import { useTheme } from '@mxa-argos/components/refine/theme/use-theme';

export const MaximilianaTitle: React.FC = () => {
  const { resolvedTheme } = useTheme();

  const logoSrc = resolvedTheme === 'light' ? '/logo_green.svg' : '/logo_white.svg';

  return (
    <a href="/" className="flex items-center gap-2">
      <img src={logoSrc} alt="Maximiliana" className="h-6 max-w-full object-contain" />
    </a>
  );
};
